import React from "react";
import NavBar_Top from "../../NavBar_Top/NavBar_Top";
import Menu_Navegacao from "./Menu_Navegacao";
import { useState, useEffect } from "react";
import { MapContainer, TileLayer, Polyline, Marker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Grid, Box, Button, TextField } from '@mui/material';
import L from 'leaflet';
import Modal from '@mui/material/Modal';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchIcon from '@mui/icons-material/Search';
import ImagemMotoboy from '../../../assets/img/motoboy_5.png';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../../services/api';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Table, TableHead, TableRow, TableBody, Paper, Typography } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import PublicIcon from '@mui/icons-material/Public';
import { CircularProgress } from "@mui/material";

import EmAndamentoIcon from '@mui/icons-material/AccessAlarms';
import CanceladaIcon from '@mui/icons-material/Clear';
import EntregueIcon from '@mui/icons-material/Check';
import Tooltip2 from '@mui/material/Tooltip';


const Planejamento = () => {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: 'green',
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 12,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const hoje = dayjs();

    const [openModalMapa, setOpenModalMapa] = useState(false);
    const [openModalMulti, setOpenModalMulti] = useState(false)
    const [motoboy, setMotoboy] = useState(null);
    const [erroMotoboy, setErroMotoboy] = useState(false);
    const [date, setDate] = useState(hoje);
    const [coordenadas, setCoordenadas] = useState([]);
    const [coordenadasMotoboy, setCoordenadasMotoboy] = useState([])
    const [listaRastrear, setListaRastrear] = useState([])
    const [temPercurso, setTemPercurso] = useState(false);
    const [dadosTabela, setDadosTabela] = useState([]);
    const [tempoPrevisto, setTempoPrevisto] = useState();
    const [tempoMotoboy, setTempoMotoboy] = useState()
    const [tabelaGrupo, setTabelaGrupo] = useState([])
    const [inforcacoesMapa, setInformacoesMapa] = useState([])

    const handleClose = () => setOpenModalMapa(false);

    const handleCloseMulti = () => setOpenModalMulti(false)

    const handleDate = (value) => {
        setDate(value)
    }

    const handleMotoboy = (value) => {
        let id = value.target.value;
        setErroMotoboy(false);
        if (id === '') {
            setErroMotoboy(true)
            DeuRuim('Motoboy não pode ficar vazio')
        }
        setMotoboy(id)
    }

    function formatDate(isoString) {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} às ${hours}:${minutes}`;
    }

    const PesquisaApi = () => {

        setTabelaGrupo(null)
        if (motoboy === null || motoboy === '') {
            DeuRuim('O ID do motoboy não pode ser Vazio ou Inválido')
            setTabelaGrupo(null)
            return
        }

        if (!ValidaData(date)) {
            DeuRuim('A Data esta em um formato Incorreto')
            setTabelaGrupo(null)
            return
        }

        api.get(`AppEntregas/Agrupamento/${motoboy}/${date}`).then((response) => {
            if (response.status === 200) {
                const minhaLista = response.data
                if (minhaLista.length > 0) {
                    setTabelaGrupo(response.data)
                }
                else {
                    MensagemDados('Nenhum informação encontrada')
                    setTabelaGrupo([])
                }
            }
        }).catch((error) => {
            if (error.response.status) {
                DeuRuim(error.response.data.detail)
            }
            setTabelaGrupo([])
            return
        })
    }



    const BuscarInformacoesMapa = (id_agrupamento) => {
        api.get(`AppEntregas/AgrupamentoMapa/${motoboy}/${id_agrupamento}`).then((response) => {
            if (response.status === 200) {
                const minhaLista = response.data
                console.log('VALOR DA MINHA LISTA ', minhaLista)
                if (minhaLista.length > 0) {

                    const coordenadasBase = minhaLista[0].coordenadas_base_nafil || [];
                    console.log('verificado o array ', coordenadasBase)
                    const coordenadasAgrupadas = minhaLista[0].coordenadas_agrupadas || [];
                    const dados_tabela = minhaLista[0].dados_tabela || [];
                    const lista_rastrear = minhaLista[0].lista_rastrear || [];

                    setTempoPrevisto(minhaLista[0].tempo_planejado);
                    setTempoMotoboy(minhaLista[0].tempo_realizado);

                    setDadosTabela(dados_tabela);

                    const baseCoord = coordenadasBase.map(parseFloat) || []

                    console.log('BASE COORDS', baseCoord)

                    const waypoints = [
                        baseCoord,
                        ...coordenadasAgrupadas.map(coord => coord.map(parseFloat)),
                        baseCoord
                    ];

                    //console.log('COORDENADAS BASE: ', coordenadasBase);
                    //console.log('MINHA LISTA:', minhaLista);
                    //console.log('DADOS DE TABELA ', dados_tabela)
                    //console.log('COORDENADAS AGRUPADAS ', coordenadasAgrupadas)
                    //console.log('WAY POINTS ', waypoints)

                    setListaRastrear(lista_rastrear);

                    setCoordenadas(waypoints);

                    setOpenModalMapa(true)
                }
                else {
                    MensagemDados('Nenhum informação encontrada')
                    setInformacoesMapa([])
                }
            }
        }).catch((error) => {
            if (error.response.status) {
                DeuRuim(error.response.data.detail)
            }
            setInformacoesMapa([])
            return
        })
    }


    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });


    const ValidaData = (value) => {
        return dayjs(value).isValid();
    }


    const DeuRuim = (mensagem) => {
        toast.error(mensagem, {
            position: "top-center",
            theme: "colored"
        });
    }


    const MensagemDados = (mensagem) => {
        toast.warning(mensagem, {
            position: "top-center",
            theme: "colored"
        });
    }

    // useEffect(() => {
    //     if (coordenadas.length > 0) {
    //         setOpenModalMapa(true)
    //     }
    // }, [coordenadas])


    // useEffect(() => {
    //     if (coordenadas.length > 0) {
    //         setOpenModalMulti(true)
    //     }
    // }, [coordenadasMotoboy])

    const ModalMapaCoordenada = () => {

        const [routeCoordinates, setRouteCoordinates] = useState([]);
        const [loading, setLoading] = useState(true);
        const [motoboyRoute, setMotoboyRoute] = useState([])
        const colors = ["green", "blue", "red", "purple", "gray", "cyan"];

        useEffect(() => {

            const fetchRoutes = async () => {

                const routes = [];

                const _coordenadas = coordenadas;

                console.log('VALOR DAS COORDENADAS AO ABRIR O MAPA ', coordenadas)

                for (let i = 0; i < _coordenadas.length - 1; i++) {
                    const start = _coordenadas[i];
                    const end = _coordenadas[i + 1];
                    const coordinatesString = `${start[1]},${start[0]};${end[1]},${end[0]}`;

                    const url = `https://router.project-osrm.org/route/v1/driving/${coordinatesString}?overview=full&geometries=geojson`;

                    try {
                        const response = await fetch(url);
                        const data = await response.json();

                        if (data.routes && data.routes.length > 0) {
                            const coordinates = data.routes[0].geometry.coordinates.map(coord => [coord[1], coord[0]]);

                            routes.push({
                                coordinates,
                                start: coordinates[0],
                                end: coordinates[coordinates.length - 1],
                                tooltip: `Rota ${i + 1}`,
                                color: colors[i % colors.length],
                            });
                        }
                    } catch (error) {
                        DeuRuim('Servidor OpenStreetMaps esta ocupado')
                        console.error(`Erro ao obter a rota entre ${start} e ${end}:`, error);
                    }
                }
                setRouteCoordinates(routes);
                setLoading(false);
                console.log('cheguei aqui ')
            };
            fetchRoutes();
        }, []);

        useEffect(() => {
            const fetchMotoboyRoute = async () => {
                const routes = [];
                const caminho_motoboy = listaRastrear;
                const _coordenadas = caminho_motoboy;

                for (let i = 0; i < _coordenadas.length - 1; i++) {
                    const start = _coordenadas[i];
                    const end = _coordenadas[i + 1];
                    const coordinatesString = `${start[1]},${start[0]};${end[1]},${end[0]}`;

                    const url = `https://router.project-osrm.org/route/v1/driving/${coordinatesString}?overview=full&geometries=geojson`;

                    try {
                        const response = await fetch(url);
                        const data = await response.json();
                        if (data.routes && data.routes.length > 0) {
                            const coordinates = data.routes[0].geometry.coordinates.map(coord => [coord[1], coord[0]]);
                            routes.push({
                                coordinates,
                                start: coordinates[0],
                                end: coordinates[coordinates.length - 1],
                                tooltip: `Rota ${i + 1}`,
                                color: colors[i % colors.length],
                            });
                        }
                    } catch (error) {
                        DeuRuim("Servirdor OpenStreetMaps ocupado, rotas não calculadas")
                        console.error(`Erro ao obter a rota entre ${start} e ${end}:`, error);
                    }
                }
                setMotoboyRoute(routes);
            };
            fetchMotoboyRoute();
        }, []);

        return (
            <>
                <Modal
                    open={openModalMapa}
                    onClose={handleClose}
                    aria-labelledby="map-modal-title"
                    aria-describedby="map-modal-description"
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '100%',
                            height: '100%',
                            bgcolor: 'background.paper',
                            p: 4,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Button
                            startIcon={<CloseIcon />}
                            color="error"
                            onClick={handleClose}
                            variant="contained"
                            size="small"
                        >
                            Fechar
                        </Button>

                        {
                            loading
                                ?
                                (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            flex: 1,
                                        }}
                                    >

                                        <CircularProgress color="success" size={80} />

                                    </Box>

                                )

                                :

                                (

                                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <Box sx={{ flex: 2, minHeight: '350px', maxHeight: '350px' }}>

                                            <MapContainer
                                                center={[-22.499826673440317, -44.107478037829665]} //Não esquecer de mudar depois
                                                zoom={12}
                                                style={{ height: '100%', width: '100%' }}
                                            >

                                                <TileLayer
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                    attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                                                />

                                                {motoboyRoute.map((route, index) => (
                                                    <React.Fragment key={index}>
                                                        <Polyline
                                                            positions={route.coordinates}
                                                            color="black"
                                                            weight={6}
                                                            opacity={1}
                                                        />
                                                        <Marker position={route.start}>
                                                            <Tooltip permanent>{route.tooltip}</Tooltip>
                                                        </Marker>
                                                        {index === routeCoordinates.length - 1 && (
                                                            <Marker position={route.end}>
                                                                <Tooltip permanent>Final do Percurso</Tooltip>
                                                            </Marker>
                                                        )}
                                                    </React.Fragment>
                                                ))}

                                                {routeCoordinates.map((route, index) => (
                                                    <React.Fragment key={index}>
                                                        <Polyline
                                                            positions={route.coordinates}
                                                            color={route.color}
                                                            weight={6}
                                                            opacity={1}
                                                        />
                                                        <Marker position={route.start}>
                                                            <Tooltip permanent>{route.tooltip}</Tooltip>
                                                        </Marker>
                                                        {index === routeCoordinates.length - 1 && (
                                                            <Marker position={route.end}>
                                                                <Tooltip permanent>Final do Percurso</Tooltip>
                                                            </Marker>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </MapContainer>
                                        </Box>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="h8" component="h8">
                                                Tempo estimado para a rota: {tempoPrevisto}
                                            </Typography>
                                            <Typography variant="h8" component="h8">
                                                Tempo realizado pelo motoboy: {tempoMotoboy}
                                            </Typography>
                                        </Box>
                                        <Box sx={{ flex: 1, minHeight: "200px", maxHeight: "400px", overflowY: "auto" }}>
                                            {Array.isArray(dadosTabela) && dadosTabela.length > 0 ? (
                                                <TableContainer component={Paper} sx={{ maxHeight: "400px", overflowY: "auto" }}>
                                                    <Table aria-label="customized table" size="small" stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <StyledTableCell align="center">Venda</StyledTableCell>
                                                                <StyledTableCell align="center">Agendada</StyledTableCell>
                                                                <StyledTableCell align="center">Conferida</StyledTableCell>
                                                                <StyledTableCell align="center">Despachada</StyledTableCell>
                                                                <StyledTableCell align="center">Entregue</StyledTableCell>
                                                                <StyledTableCell align="center">Itens</StyledTableCell>
                                                                <StyledTableCell align="center">Cliente</StyledTableCell>
                                                                <StyledTableCell align="center">Razão social</StyledTableCell>
                                                                <StyledTableCell align="center">Bairro</StyledTableCell>
                                                                <StyledTableCell align="center">Telefone</StyledTableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dadosTabela.map((row) => (
                                                                <StyledTableRow key={row.id_agrupamento}>
                                                                    <StyledTableCell align="center">{row.venda}</StyledTableCell>
                                                                    <StyledTableCell align="center">{new Date(row.agendada).toLocaleString()}</StyledTableCell>
                                                                    <StyledTableCell align="center">{new Date(row.conferida).toLocaleString()}</StyledTableCell>
                                                                    <StyledTableCell align="center">{new Date(row.despachada).toLocaleString()}</StyledTableCell>
                                                                    <StyledTableCell align="center">
                                                                        {row.entregue ? new Date(row.entregue).toLocaleString() : "Não entregue"}
                                                                    </StyledTableCell>
                                                                    <StyledTableCell align="center">{row.itens}</StyledTableCell>
                                                                    <StyledTableCell align="center">{row.cliente_loja}</StyledTableCell>
                                                                    <StyledTableCell align="center">{row.razao_social}</StyledTableCell>
                                                                    <StyledTableCell align="center">{row.bairro}</StyledTableCell>
                                                                    <StyledTableCell align="center">{row.telefone}</StyledTableCell>
                                                                </StyledTableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            ) : (
                                                "Tabela não disponível"
                                            )}
                                        </Box>
                                    </Box>
                                )}
                    </Box>
                </Modal>

            </>
        );
    };



    // const handleMapaClick = (idAgrupamentos, venda) => {
    //     const agrupamento_base = buscarPorIdAgrupamentos(idAgrupamentos, venda);
    //     const agrupamento = listaComvem;
    //     console.log('campo buscado para o agrupamento ', agrupamento)
    //     setCoordenadas([]);
    //     if (agrupamento) {
    //         const coordenadasBase = agrupamento.coordenadas_base || [];
    //         const coordenadasAgrupadas = agrupamento.coordenadas_agrupadas || [];
    //         const dados_tabela = agrupamento.dados_tabela || [];

    //         setTempoPrevisto(agrupamento.tempo_planejado);
    //         setTempoMotoboy(agrupamento.tempo_realizado);
    //         setDadosTabela(dados_tabela);

    //         const baseCoord = coordenadasBase[0]?.split(',').map(parseFloat) || []; 
    //         const waypoints = [
    //             baseCoord,
    //             ...coordenadasAgrupadas.map(coord => coord.map(parseFloat)),
    //             baseCoord
    //         ];
    //         console.log('Coordenadas base:', coordenadasBase);
    //         console.log('Valor do resultado do agrupamento:', agrupamento);
    //         setCoordenadas(waypoints);
    //     } else {
    //         console.log('Agrupamento não encontrado.');
    //         DeuRuim('Agrupamento não encontrado.')
    //     }
    // };

    const RenderStatus = (id, data_entregue, data_cancelada, motivo) => {
        if (id == 0) {
            return (
                <Tooltip2 title="Entrega em andamento">
                    <EmAndamentoIcon fontSize="large" color="primary" />
                </Tooltip2>
            );
        }

        if (id == 1) {

            return (
                <Tooltip2 title={`Entregue dia ${data_entregue}`}>
                    <EntregueIcon fontSize="large" color='success' />
                </Tooltip2>
            );
        }

        if (id == 2) {
            return (
                <Tooltip2 title={`Cancelada dia ${data_cancelada} - ${motivo}`}>
                    <CanceladaIcon fontSize="large" color='error' />
                </Tooltip2>
            );
        }
    }


    return (
        <>
            <NavBar_Top />
            <br />
            <Menu_Navegacao />
            <br />
            <br />
            <br />
            <br />
            <Box sx={{ width: '800px', mx: 'auto' }}>
                <Grid
                    container
                    spacing={3}
                    justifyContent="space-evenly"
                    alignItems="center"
                >
                    <Grid item xs={12} md={4}>
                        <TextField
                            id="motoboy"
                            onChange={(e) => handleMotoboy(e)}
                            label="Motoboy"
                            error={erroMotoboy}
                            fullWidth
                            type="number"
                            variant="outlined"
                        />
                    </Grid>

                    <Grid item xs={12} md={4} >
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                            <DesktopDatePicker
                                label="Data"
                                value={date}
                                onChange={(e) => {
                                    handleDate(e);
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} md={4} >
                        <Button
                            size="large"
                            fullWidth
                            startIcon={<SearchIcon />}
                            color="success"
                            variant="contained"
                            onClick={PesquisaApi}
                        >
                            Buscar
                        </Button>
                    </Grid>
                </Grid>

            </Box>

            <Box sx={{ width: '1200x', mx: 'auto' }}>
                <br />
                <br />
                <br />
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {
                        Array.isArray(tabelaGrupo) && tabelaGrupo.length > 0

                            ?

                            <Box sx={{ width: '1200px', mx: 'auto' }}>

                                <TableContainer component={Paper}>
                                    <Table aria-label="customized table">
                                        <TableHead>

                                            <TableRow>
                                                <StyledTableCell align="center">Grupo</StyledTableCell>
                                                <StyledTableCell align="center">Motoboy</StyledTableCell>
                                                <StyledTableCell align="center">Pré Venda</StyledTableCell>
                                                <StyledTableCell align="center">Cliente</StyledTableCell>
                                                <StyledTableCell align="center">Local</StyledTableCell>
                                                <StyledTableCell align="center">Valor R$</StyledTableCell>
                                                <StyledTableCell align="center">Status</StyledTableCell>
                                                <StyledTableCell align="center"></StyledTableCell>
                                            </TableRow>

                                        </TableHead>

                                        <TableBody>

                                            {tabelaGrupo.map(row => (
                                                <StyledTableRow key={row.id_agrupamentos}>
                                                    <StyledTableCell align="center">{row.id_agrupamentos}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.motoboy}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.prevenda_loja}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.cliente_id_loja_nome}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.bairro_cidade}</StyledTableCell>
                                                    <StyledTableCell align="center">{row.valor_total}</StyledTableCell>
                                                    <StyledTableCell align="center">{RenderStatus(row.status_entrega, formatDate(row.data_entrega), formatDate(row.data_cancelamento), row.motivo_cancelamento)}</StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <Button color='primary' onClick={() => BuscarInformacoesMapa(row.id_agrupamentos)} variant="contained" startIcon={<PublicIcon />}>
                                                            Mapa
                                                        </Button>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            ))}

                                        </TableBody>

                                    </Table>

                                </TableContainer>
                            </Box>

                            :

                            <img src={ImagemMotoboy} width="500px" alt="Sem dados para exibir" />


                    }
                </Grid>
            </Box>
            <ModalMapaCoordenada />
            {/* <ModalMapaMultiCoordenadas /> */}
            <ToastContainer />
        </>
    );

}

export default Planejamento;


